import Vue from "vue";
import vueFilters from "./vue-filters";
import { updateCart } from "./request";

export default function init() {
    var el = document.getElementById("voucher-app");
    if (!el) return;
    var token = el.getAttribute("data-token");

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: vueFilters,
        data: {
            options: {},
            loading: true,
            count: 1,
        },
        created: function () {},
        mounted: async function () {
            this.loading = false;
        },
        computed: {},
        methods: {
            increaseQty: function (count) {
                this.count = parseInt(this.count) + parseInt(count);
            },
            decreaseQty: function (count) {
                if (this.count > 1) {
                    this.count = this.count - parseInt(count);
                }
            },
            handleSubmit: async function (e, purchasableId) {
                e.preventDefault();

                await updateCart(token, {
                    purchasableId: purchasableId,
                    qty: this.count,
                    options: this.options
                });

                window.openCartPopup();
                window.scrollTo(0, 0);

                this.options = {};
                this.$refs.productForm.reset();
            },
        },
        watch: {},
    });
}
